export default __webpack_public_path__ + "static/media/dropdown-arrow.8947a8fa.svg";